var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.43 217.102C102.43 210.539 107.742 205.227 114.305 205.227C120.789 205.227 126.102 210.539 126.102 217.102C126.102 223.586 120.789 228.898 114.305 228.898C107.742 228.898 102.43 223.586 102.43 217.102ZM190.32 217.102C190.32 210.539 195.633 205.227 202.195 205.227C208.68 205.227 213.992 210.539 213.992 217.102C213.992 223.586 208.68 228.898 202.195 228.898C195.633 228.898 190.32 223.586 190.32 217.102Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.99 105.85C218.756 105.85 221.881 107.491 225.006 111.085C228.131 114.678 228.678 119.835 227.975 124.514L220.553 175.764C219.146 185.616 210.709 192.874 200.787 192.874H115.553C105.162 192.874 96.5683 184.905 95.7089 174.6L88.5214 89.4362L76.7245 87.4049C73.5995 86.8581 71.412 83.8112 71.9589 80.6862C72.5058 77.4831 75.5527 75.3737 78.7558 75.8424L97.3886 78.6549C100.045 79.1315 101.998 81.3112 102.232 83.9674L103.717 101.467C103.951 103.975 105.982 105.85 108.482 105.85H213.99ZM166.646 146.467H188.287C191.568 146.467 194.146 143.811 194.146 140.608C194.146 137.327 191.568 134.749 188.287 134.749H166.646C163.365 134.749 160.787 137.327 160.787 140.608C160.787 143.811 163.365 146.467 166.646 146.467Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.b03da2d3ce1fb36d41760766b32368bf.svg";
export { ForwardRef as ReactComponent };